import { render, staticRenderFns } from "./IntervalsList.vue?vue&type=template&id=26778101&scoped=true"
import script from "./IntervalsList.vue?vue&type=script&lang=js"
export * from "./IntervalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26778101",
  null
  
)

export default component.exports